<!-- Единый переключатель из нескольких взаимоисключающих режимов -->
<template>
  <div class="segmented-control" role="group">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="segmented-control__button"
      :class="{
        'segmented-control__button--active':
          option.value === modelValue,
      }"
      :disabled="disabled || option.disabled"
      @click="selectOption(option)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: "BaseSegmentedControl",

  props: {
    modelValue: {
      type: [String, Number, Boolean],
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["update:modelValue", "change"],

  methods: {
    selectOption(option) {
      if (this.disabled || option.disabled) return;
      if (option.value === this.modelValue) return;

      this.$emit("update:modelValue", option.value);
      this.$emit("change", option.value, option);
    },
  },
};
</script>

<style scoped>
.segmented-control {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border-radius: 6px;
  background: var(--color-grey);
}

.segmented-control__button {
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #6b7280;
  padding: 4px 14px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.segmented-control__button:hover:not(:disabled) {
  background: #fff;
  color: var(--color-dark);
}

.segmented-control__button--active {
  background: #fff;
  color: var(--color-dark);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.segmented-control__button--active:hover:not(:disabled) {
  background: #fff;
  color: var(--color-dark);
}

.segmented-control__button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
